export const breakpoints = {
  xs: 480, // 480
  sm: 600, // 600
  md: 720, // 720
  lg: 960, // 960
  xl: 1200, // 1200

  // define max-width breakpoints
  max_sm: "@media (max-width: 599px)",
  max_md: "@media (max-width: 719px)",
  max_lg: "@media (max-width: 959px)",
  max_xl: "@media (max-width: 1199px)",

  // define breakpoint ranges
  sm_to_md: "@media (min-width: 600px) and (max-width: 719px)",
  sm_to_lg: "@media (min-width: 600px) and (max-width: 959px)",
  sm_to_xl: "@media (min-width: 600px) and (max-width: 1199px)",
  md_to_lg: "@media (min-width: 720px) and (max-width: 959px)",
  md_to_xl: "@media (min-width: 720px) and (max-width: 1199px)",
  lg_to_xl: "@media (min-width: 960px) and (max-width: 1199px)"
}
